import { render, staticRenderFns } from "./equipmentNfc.vue?vue&type=template&id=f31253aa&scoped=true"
import script from "./equipmentNfc.vue?vue&type=script&lang=js"
export * from "./equipmentNfc.vue?vue&type=script&lang=js"
import style0 from "./equipmentNfc.vue?vue&type=style&index=0&id=f31253aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31253aa",
  null
  
)

export default component.exports